import Role from 'models/core/role/Model.Role';
import Model from 'models/Model';
import contractRefundInvoiceEmailTemplateDeleteApi from './delete/Api.ContractRefundInvoiceEmailTemplate.Delete';
import contractRefundInvoiceEmailTemplateListApi from './list/Api.ContractRefundInvoiceEmailTemplate.List';
import contractRefundInvoiceEmailTemplateSaveApi from './save/Api.ContractRefundInvoiceEmailTemplate.Save';

export default class ContractRefundInvoiceEmailTemplate
  extends Model<Model.IContractRefundInvoiceEmailTemplate>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IContractRefundInvoiceEmailTemplate>
{
  id: number;
  name: string;
  contractRefundInvoiceStatusTrigger: Model.Enum.ContractRefundInvoiceStatusTriggers;
  senderEmail: string;
  senderName: string;
  subject: string;
  htmlBody: string;
  recipientsWithRole?: Role[];

  sendToOwner: boolean = false;
  sendToRepresentative: boolean = false;
  sendToDealersAccounting: boolean = false;
  additionalRecipientEmails: string[] = [];
  carbonCopies: string[] = [];

  languageIsoCode?: Locale.Languages;
  readonly baseEntityId: number;

  constructor(
    data:
      | Partial<Model.IContractRefundInvoiceEmailTemplate>
      | Utils.FormData<Model.IContractRefundInvoiceEmailTemplate>,
    language?: Locale.Languages
  ) {
    super(
      {
        recipientsWithRole: [Role],
      },
      language
    );
    this.update(data);
    if (!this.additionalRecipientEmails) this.additionalRecipientEmails = [];
    if (!this.carbonCopies) this.carbonCopies = [];
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.name,
      info: this.senderName,
      subtitle: this.senderEmail,
    };
  }
  static async list(body?: Api.Core.ContractRefundInvoiceEmailTemplate.List.IRequest) {
    const { payload, ...rest } = await contractRefundInvoiceEmailTemplateListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ContractRefundInvoiceEmailTemplate(it)),
        count: payload.count,
      },
    };
  }
  async save() {
    return await contractRefundInvoiceEmailTemplateSaveApi(this);
  }
  async delete() {
    return await contractRefundInvoiceEmailTemplateDeleteApi(this.id);
  }
}
